import React from "react";
import {
  Grid,
  TextField,
  Switch,
  FormControlLabel,
  Typography,
  Box,
  useTheme,
} from "@mui/material";

interface Props {
  config: any;
  onChange: (field: string, value: any) => void;
}

const HomenetForm: React.FC<Props> = ({ config, onChange }) => {
  const theme = useTheme();
  const red = theme.palette.status.accent; // UMS red accent

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderLeft: `3px solid ${red}`,
        borderRadius: 2,
        p: 2,
        mt: 1,
        boxShadow: "0 0 6px rgba(0,0,0,0.3)",
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          mb: 2,
          fontWeight: 600,
          color: red,
          letterSpacing: 0.3,
        }}
      >
        HomeNet IOL Configuration
      </Typography>

      <Grid container spacing={2}>
        {/* Dealer ID */}
        <Grid item xs={6}>
          <TextField
            label="Dealer ID"
            fullWidth
            value={config.dealerID || ""}
            onChange={(e) => onChange("dealerID", e.target.value)}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>

        {/* includePanoIframe Switch */}
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <Switch
                checked={config.includePanoIframe ?? false}
                onChange={(e) =>
                  onChange("includePanoIframe", e.target.checked)
                }
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": { color: red },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: red,
                  },
                }}
              />
            }
            label={
              <Typography sx={{ fontWeight: 500 }}>
                Include Pano Iframe
              </Typography>
            }
          />
        </Grid>

        {/* URL Order Fields */}
        <Grid item xs={12}>
          <Typography
            variant="subtitle2"
            sx={{
              mt: 1,
              mb: 1,
              color: red,
              fontWeight: 600,
            }}
          >
            Image Tag URL Orders
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="BGR Exterior Tag Order"
            fullWidth
            value={config.imageBgrExterior_tagUrlOrder || ""}
            onChange={(e) =>
              onChange("imageBgrExterior_tagUrlOrder", e.target.value)
            }
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="BGR Manual Tag Order"
            fullWidth
            value={config.imageBgrManual_tagUrlOrder || ""}
            onChange={(e) =>
              onChange("imageBgrManual_tagUrlOrder", e.target.value)
            }
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="BGR Pano Tag Order"
            fullWidth
            value={config.imageBgrPano_tagUrlOrder || ""}
            onChange={(e) =>
              onChange("imageBgrPano_tagUrlOrder", e.target.value)
            }
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="Crop Tag Order"
            fullWidth
            value={config.imageCrop_tagUrlOrder || ""}
            onChange={(e) => onChange("imageCrop_tagUrlOrder", e.target.value)}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="Exterior Tag Order"
            fullWidth
            value={config.imageExterior_tagUrlOrder || ""}
            onChange={(e) =>
              onChange("imageExterior_tagUrlOrder", e.target.value)
            }
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="Featured Tag Order"
            fullWidth
            value={config.imageFeatured_tagUrlOrder || ""}
            onChange={(e) =>
              onChange("imageFeatured_tagUrlOrder", e.target.value)
            }
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="Manual Tag Order"
            fullWidth
            value={config.imageManual_tagUrlOrder || ""}
            onChange={(e) =>
              onChange("imageManual_tagUrlOrder", e.target.value)
            }
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Group URL Order"
            fullWidth
            value={config.imageGroupUrlOrder || ""}
            onChange={(e) => onChange("imageGroupUrlOrder", e.target.value)}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default HomenetForm;
